var map = {
  "./cs.json": [
    "Wn1",
    [
      "0b"
    ]
  ],
  "./en.json": [
    "gN",
    [
      "qk"
    ]
  ],
  "./pl.json": [
    "qaB",
    [
      "o8"
    ]
  ],
  "./ru.json": [
    "HN8",
    [
      "h75"
    ]
  ],
  "./tr.json": [
    "Vvn",
    [
      32
    ]
  ],
  "./ja.json": [
    "ghy",
    [
      "yw"
    ]
  ],
  "./zh.json": [
    "cLI",
    [
      "ms"
    ]
  ],
  "./pt-br.json": [
    "fbc",
    [
      "ha"
    ]
  ],
  "./de.json": [
    "R8",
    [
      "ro"
    ]
  ],
  "./es.json": [
    "Hr",
    [
      "xd"
    ]
  ],
  "./fr.json": [
    "WKa",
    [
      "sxk"
    ]
  ],
  "./it.json": [
    "XF",
    [
      "1nn"
    ]
  ],
  "./ko.json": [
    "Np",
    [
      "b2q"
    ]
  ],
  "./pt.json": [
    "h2p",
    [
      "n8"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "dE";
module.exports = __rspack_async_context;
